import ConsumerSummary from './consumer-summary';

export default ConsumerSummary;
